import React from "react";

import classes from "./SectionHeading.css";
import Grid from "@material-ui/core/Grid";

const gridSpacing = 0; //0 or 8 or 16 or 24 or 32 or 40

const SectionHeading = (props) => {
  return (
    <Grid container item spacing={gridSpacing}>
      {/* <Grid item xs={5}>
        <hr />
      </Grid>
      <Grid item xs={2}>
        <p className={classes.title}>{props.sectionTitle}</p>
      </Grid>
      <Grid item xs={5}>
        <hr />
      </Grid> */}
      <Grid item xs={12}>
        <p className={classes.title}>{props.sectionTitle}</p>
      </Grid>
    </Grid>
  );
};

export default SectionHeading;
